module.exports = __webpack_public_path__ + "media/taipei/taipei park-0a18a201.jpg";